import {wizardsService} from "@/modules/common/services";
import {settingsService} from "../../settings/services/settingsService";
import {xpertWizardsService} from "@/modules/wizards/services/xpertWizardsService";

const state = {
  wizard: null,
};

const getters = {
  wizard: state => {
    return state.wizard
  },
};

const mutations = {
  setWizard : (state,wizard) => {
    state.wizard = wizard
  },
};


const actions = {
  checkIncompleteXpertSignup : async  ({commit},business) => {
    try {
      return await xpertWizardsService.checkIncompleteXpertSignup(business)
    } catch (e) {
      console.log("check incomplete xpert error", e)
    }
  },
  createVcitaXpertEntities: async  ({commit},business) => {
    try {
      let data = {
        businessUid: business.businessUid,
        phone_number: business.phone,
        name: business.accountName,
        password: business.password,
      }
      return await xpertWizardsService.createVcitaXpertEntities(data)

    } catch (e) {
      console.log("create vcita xpert error", e)
    }
  },
  fetchWizard : async  ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.getPaymentWizard(data.business_uid)
      commit('setWizard',wizard )
    } catch (e) {
      console.log("fetchWizard", e)
    }
  },
  updateWizardFlags : async ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.updateWizardFlags(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
    } catch (e) {
      console.log("updateWizardFlags", e)
    }
  },
  updateWizardCompleted: async ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.wizardCompleted(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
    } catch (e) {
      console.log("updateWizardCompleted", e)
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
